import React from "react";
import "../css/fintracker.css";
import Tracker from "../images/tracker.svg";
const FinTracker = () => {
  return (
    <div className="fin-tracker">
      <p className="title">Financing Tracker</p>
      <div className="content">
        <div className="metrics">
          <img src={Tracker} alt="" />
          <div>
            <span className="time">Days</span>
            <span className="time">Hours</span>
            <span className="time">Days</span>
            <span className="time">Hours</span>
          </div>
          <p className="timestamp">25:06:21:23</p>
        </div>
        <div>
          <div className="track-stat">
            <p className="stat-name">Collected Date</p>
            <p className="stat-figure">10 June 2022</p>
          </div>
          <div className="track-stat">
            <p className="stat-name">Payment Date</p>
            <p className="stat-figure">10 June 2022</p>
          </div>
          <div className="track-stat">
            <p className="stat-name">Financing Period</p>
            <p className="stat-figure">10 Months</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FinTracker;
